import factory from './icon';
import Svg from './glyphs/email.svg';

export default factory(Svg);
